import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, ax, card, btn, inp, ImageUploadZone } from './adminHelpers';

export default function PackagesTab() {
  const [packages, setPackages] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', badge_label: '', description: '', hours: 2, features: [], visible: true });
  const [featInput, setFeatInput] = useState('');
  const [file, setFile] = useState(null);

  const load = () => ax().get(`${API}/api/admin/packages`).then(r => setPackages(r.data.packages)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    const fd = new FormData();
    fd.append('name', form.name);
    fd.append('badge_label', form.badge_label);
    fd.append('description', form.description);
    fd.append('hours', form.hours);
    fd.append('visible', form.visible);
    fd.append('features', JSON.stringify(form.features));
    if (file) fd.append('image', file);

    if (editing) {
      await axios.patch(`${API}/api/admin/packages/${editing}`, fd, { withCredentials: true });
    } else {
      await axios.post(`${API}/api/admin/packages`, fd, { withCredentials: true });
    }
    setEditing(null);
    setForm({ name: '', badge_label: '', description: '', hours: 2, features: [], visible: true });
    setFile(null);
    load();
  };

  const toggle = async (pkg) => { await ax().patch(`${API}/api/admin/packages/${pkg.id}`, { visible: !pkg.visible }); load(); };
  const parseFeatures = (f) => Array.isArray(f) ? f : (typeof f === 'string' ? JSON.parse(f || '[]') : []);
  const edit = (pkg) => { setEditing(pkg.id); setForm({ name: pkg.name, badge_label: pkg.badge_label || '', description: pkg.description || '', hours: pkg.hours, features: parseFeatures(pkg.features), visible: pkg.visible }); setFile(null); };
  const del = async (id) => { if (window.confirm('Delete package?')) { await ax().delete(`${API}/api/admin/packages/${id}`); load(); } };
  const addFeat = () => { if (featInput.trim()) { setForm(f => ({ ...f, features: [...f.features, featInput.trim()] })); setFeatInput(''); } };
  const remFeat = (i) => setForm(f => ({ ...f, features: f.features.filter((_, j) => j !== i) }));

  return (
    <div>
      <div style={card}>
        <h3 style={{ margin: '0 0 16px', color: '#9F5CFF', fontSize: 15 }}>{editing ? 'Edit Package' : 'Add Package'}</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          <input placeholder="Package name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inp(false)} />
          <input placeholder="Badge label (e.g. Most Popular)" value={form.badge_label} onChange={e => setForm({ ...form, badge_label: e.target.value })} style={inp(false)} />
        </div>

        <textarea placeholder="Description" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
          style={{ ...inp(false), height: 80, resize: 'vertical', fontFamily: 'inherit', marginBottom: 10 }} />

        <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
          <input placeholder="Hours" type="number" value={form.hours} onChange={e => setForm({ ...form, hours: parseInt(e.target.value) || 2 })} style={{ ...inp(false), width: 100 }} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#a0a0b8', fontSize: 13 }}>
            <input type="checkbox" checked={form.visible} onChange={e => setForm({ ...form, visible: e.target.checked })} /> Visible on site
          </label>
        </div>

        <ImageUploadZone label="Package Display Image" file={file} onChange={e => setFile(e.target.files[0])} />

        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <input placeholder="Add feature…" value={featInput}
            onChange={e => setFeatInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && addFeat()}
            style={{ ...inp(false), flex: 1 }} />
          <button onClick={addFeat} style={btn('#9F5CFF')}>+ Add Feature</button>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 20 }}>
          {form.features.map((f, i) => (
            <span key={i} onClick={() => remFeat(i)}
              style={{ background: 'rgba(159,92,255,0.12)', color: '#9F5CFF', fontSize: 12, padding: '4px 10px', borderRadius: 50, border: '1px solid rgba(159,92,255,0.3)', cursor: 'pointer' }}>
              {f} ✕
            </span>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={save} style={btn('#9F5CFF')}>💾 Save Package</button>
          {editing && (
            <button onClick={() => { setEditing(null); setForm({ name: '', badge_label: '', description: '', hours: 2, features: [], visible: true }); setFile(null); }} style={btn('#555', true)}>
              Cancel
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 14 }}>
        {packages.map(pkg => (
          <div key={pkg.id} style={{ ...card, opacity: pkg.visible ? 1 : 0.6, padding: 0, overflow: 'hidden' }}>
            {pkg.image_url
              ? <img src={pkg.image_url} alt={pkg.name} style={{ width: '100%', height: 140, objectFit: 'cover' }} />
              : <div style={{ width: '100%', height: 140, background: 'rgba(255,255,255,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: 36, opacity: 0.4 }}>📦</span>
                </div>
            }
            <div style={{ padding: 20 }}>
              <p style={{ margin: '0 0 4px', fontSize: 15, color: '#fff', fontWeight: 700 }}>{pkg.name}</p>
              {pkg.badge_label && <span style={{ fontSize: 11, background: '#9F5CFF', color: '#fff', padding: '2px 6px', borderRadius: 4, fontWeight: 700 }}>{pkg.badge_label}</span>}
              <p style={{ margin: '6px 0 12px', fontSize: 12, color: '#a0a0b8' }}>{pkg.description}</p>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => toggle(pkg)} style={btn(pkg.visible ? '#27C85A' : '#555', true)}>{pkg.visible ? 'Visible' : 'Hidden'}</button>
                <button onClick={() => edit(pkg)} style={btn('#9F5CFF', true)}>Edit</button>
                <button onClick={() => del(pkg.id)} style={btn('#E34364', true)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
